module.exports = __webpack_public_path__ + "static/media/logo.c39cef91.png";